<div class="container">
  <header class="toolbar">
    <h1>Mtrki03 Management</h1>
    <button mat-button (click)="onNewRecord()">新增</button>
  </header>

  <section class="search-sort">
    <mat-form-field appearance="fill" class="search-field">
      <mat-label>搜尋</mat-label>
      <input matInput placeholder="搜尋主旨或內容" (input)="onSearch($event.target.value)">
    </mat-form-field>

    <mat-form-field appearance="fill" class="sort-field">
      <mat-label>排序方式</mat-label>
      <mat-select [(value)]="sortOption" (selectionChange)="onSortChange()">
        <mat-option value="dateDesc">日期 (DESC)</mat-option>
        <mat-option value="sortAsc">排序序號 (ASC)</mat-option>
      </mat-select>
    </mat-form-field>
  </section>

  <section class="table-container">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- Star Column -->
      <ng-container matColumnDef="WL008">
        <th mat-header-cell *matHeaderCellDef> 星號 </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox [(ngModel)]="row.WL008" (change)="onStarToggle(row)" [color]="'primary'">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Date Column -->
      <ng-container matColumnDef="WL005">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 日期 </th>
        <td mat-cell *matCellDef="let row"> {{ row.WL005 }} </td>
      </ng-container>

      <!-- Sort Column -->
      <ng-container matColumnDef="WL003">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 排序碼 </th>
        <td mat-cell *matCellDef="let row"> {{ row.WL003 }} </td>
      </ng-container>

      <!-- Subject Column -->
      <ng-container matColumnDef="WL007">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 主旨 </th>
        <td mat-cell *matCellDef="let row"> {{ row.WL007 }} </td>
      </ng-container>

      <!-- Content Column -->
      <ng-container matColumnDef="WL004">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> 內文 </th>
        <td mat-cell *matCellDef="let row">
          <div class="content-preview">
            {{ row.WL004 | slice:0:50 }}{{ row.WL004.length > 50 ? '...' : '' }}
          </div>
          <app-stt></app-stt>
        </td>
      </ng-container>

      <!-- Sequence Column -->
      <ng-container matColumnDef="WL002">
        <th mat-header-cell *matHeaderCellDef> 序號 </th>
        <td mat-cell *matCellDef="let row"> {{ row.WL002 }} </td>
      </ng-container>

      <!-- ID Column -->
      <ng-container matColumnDef="WL001">
        <th mat-header-cell *matHeaderCellDef> 單號 </th>
        <td mat-cell *matCellDef="let row"> {{ row.WL001 }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onEditRecord(row)"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
  </section>

  <!-- STT Recording Button -->
  <div class="stt-container">
    <button mat-fab color="primary" (click)="toggleSttRecording()" [disabled]="isSttRecording" class="stt-record-btn">
      <mat-icon>{{ isSttRecording ? 'mic' : 'mic_none' }}</mat-icon>
    </button>
    @if (isSttRecording) {
    <div class="stt-status">錄音中...</div>
    }
    @if (transcribedText) {
    <div class="stt-transcription" >
      轉錄結果: {{ transcribedText }}
    </div>
    }
  </div>
</div>
